import { TabletButton } from '@campfire/tablet-button';
import { Menu, MenuItem } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import { incidentStatusOptions } from '../IncidentManagementConsts';

export const IncidentManagementStatusMobileMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [query, setQuery] = useQueryParams({
    tab: StringParam,
  });

  useEffect(() => {
    if (!query.tab) setQuery({ ...query, tab: 'new' });
  }, [query.tab]);

  const handleOpenIncidentStatusDropdown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseIncidentStatusDropdown = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <TabletButton
        size='small'
        variant='outlined'
        color='primary'
        aria-controls='incident-status-menu'
        aria-haspopup='true'
        onClick={handleOpenIncidentStatusDropdown}
        endIcon={<ExpandMore />}
        style={{
          border: '1px solid #9e9e9e',
          boxSizing: 'border-box',
          borderRadius: '4px',
          padding: '7px 12px',
          color: '#444444',
          marginRight: '8px',
          minWidth: '100px',
          fontSize: '16px',
          fontWeight: 900,
        }}
      >
        {query.tab ? incidentStatusOptions.find((option) => option.value === query.tab)?.label : null}
      </TabletButton>
      <Menu
        id='incident-status-menu'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseIncidentStatusDropdown}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {incidentStatusOptions.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              setQuery({ tab: option.value });
              handleCloseIncidentStatusDropdown();
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
